import { Skeleton, Box } from '@mui/material'
const Audio = (): JSX.Element => {
  return (
    <>
      <span className='relative flex h-2 w-2 mr-2'>
        <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-80' />
      </span>
    </>
  )
}

export default Audio

export const SwapSkeleton = () => {
  return (
    <Box className='container mx-auto mt-10 flex flex-col-reverse p-2 2xl:flex-row items-center'>
      <Skeleton variant='rectangular' width={500} height={500} className='flex flex-col max-w-[500px] justify-center items-center p-2 mx-auto rounded-2xl border border-primary border-opacity-25 bg-bgColor' />
    </Box>
  )
}
